import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { authApi, extractApiError } from '@/lib/api'
import { useAuthStore } from '@/stores/auth.store'
import { Button, Input } from '@/components/ui'
import type { UserRole } from '@/types'
import { LoginShell } from '@/pages/auth/LoginShell'

export function LoginPageSaas() {
  const navigate = useNavigate()
  const setAuth = useAuthStore((s) => s.setAuth)

  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleEmailLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const response = await authApi.loginEmail(email.trim(), password)
      const rd = response.data as Record<string, unknown>
      if (response.status === 401 || rd?.success === false) {
        setError((rd?.error as string) || 'Неверный логин или пароль')
        return
      }
      const role = (rd.role as UserRole) || 'admin'
      const roleName = (rd.role_name as string) || 'Администратор'
      setAuth(role, roleName, {
        userId: rd.user_id as string | undefined,
        email: rd.email as string | undefined,
        tenantId: rd.tenant_id as string | undefined,
        tenantSlug: rd.tenant_slug as string | undefined,
      })
      navigate(role === 'admin' ? '/admin' : '/worker', { replace: true })
    } catch (err) {
      setError(extractApiError(err) || 'Неверный логин или пароль')
    } finally {
      setLoading(false)
    }
  }

  return (
    <LoginShell>
      <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center">Вход в кабинет</h2>
      {error && (
        <div className="mb-4 rounded-lg bg-red-50 border border-red-200 p-3 text-sm text-red-700">{error}</div>
      )}
      <form onSubmit={handleEmailLogin} className="space-y-3">
        <Input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          required
        />
        <Input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        <Button type="submit" className="w-full" isLoading={loading}>
          Войти
        </Button>
      </form>
      <p className="mt-4 text-center text-sm text-gray-500">
        Есть ссылка-приглашение?{' '}
        <Link to="/login" className="text-blue-600 hover:underline">
          Откройте её из письма
        </Link>
      </p>
    </LoginShell>
  )
}
